import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { AuthGuard } from '@myproject/auth.guard';
import { LoginComponent } from '@layouts/login/login.component';
import { ModuleWithProviders } from '@angular/core';
import { LayoutComponent } from '@components/layout/layout.component';
import { ForgotPasswordComponent } from '@layouts/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from '@layouts/reset-password/reset-password.component';
import { CustomPreloadingStrategy } from '@myproject/lazy-loadding.preloading';
import { PageNotFoundComponent } from '@shared/errors/page-not-found.component';
import { PermissionGuard } from '@myproject/perimission.guard';
import { SupportViewGuard } from '@myproject/support-view.guard';
import { ContactUsComponent } from '@layouts/contact-us/contact-us.component';
import { FaqComponent } from '@layouts/faq/faq.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'logout',
    component: LoginComponent
  },
  {
    path: 'refresh',
    component: LoginComponent
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'reset-password/:id',
    component: ResetPasswordComponent
  },
  {
    path: '', redirectTo: 'live', pathMatch: 'full'
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'contact-us',
        component: ContactUsComponent
      },
      {
        path: 'faq',
        component: FaqComponent
      },
      // {
      //   path: 'devices',
      //   loadChildren: () => import('@components/device/device.module').then(m => m.DeviceModule),
      //   // data: { moduleName: 'DEVICE' },
      //   // canActivate: [PermissionGuard]
      // },
      {
        path: 'v2/devices',
        loadChildren: () => import('@components/central-device/device.module').then(m => m.DeviceModule),
        // data: { moduleName: 'DEVICE' },
        // canActivate: [PermissionGuard]
      },
      {
        path: 'admin',
        loadChildren: () => import('@components/admin/admin.module').then(m => m.AdminModule),
        canActivate: [PermissionGuard],
        data: { moduleName: "ADMIN" },
      },
      {
        path: "marketplace",
        loadChildren: () =>
          import("./components/admin/marketplace/marketplace.module").then(
            (m) => m.MarketplaceModule
          ),
        // canActivate: [PermissionGuard],
        data: { moduleName: "MARKETPLACE" },
      },
      // {
      //   path: 'ota',
      //   loadChildren: () => import('@components/ota/ota.module').then(m => m.OtaModule),
      //   data: { moduleName: 'OTA' },
      //   canActivate: [PermissionGuard]
      // },
      {
        path: 'v2/ota',
        loadChildren: () => import('@components/central-ota/ota.module').then(m => m.OtaModule),
        data: { moduleName: 'OTA' },
        canActivate: [PermissionGuard]
      },
      {
        path: 'support',
        loadChildren: () => import('@components/support/support.module').then(m => m.SupportModule),
        data: { moduleName: 'SUPPORT' },
        canActivate: [PermissionGuard]
      },
      {
        path: 'overview',
        loadChildren: () => import('@components/dashboard-overview/dashboard-overview.module').then(m => m.DashboardOverviewModule),
        data: { moduleName: 'SUPPORT' },
        canActivate: [PermissionGuard]
      },
      {
          path: 'dashboard',
          loadChildren: () => import('@components/dashboard-home/dashboard-home.module').then(m => m.DashboardHomeModule),
          data: { moduleName: 'SUPPORT-DASHBOARD' },
          canActivate: [PermissionGuard, SupportViewGuard]
        },
      {
          path: 'chargers',
          loadChildren: () => import('@components/chargers/charger.module').then(m => m.ChargerModule),
          data: { moduleName: 'SUPPORT-DASHBOARD' },
          canActivate: [PermissionGuard, SupportViewGuard]
        },
      {
          path: 'vehicles',
          loadChildren: () => import('@components/vehicles/vehicle.module').then(m => m.VehicleModule),
          data: { moduleName: 'SUPPORT-DASHBOARD' },
          canActivate: [PermissionGuard, SupportViewGuard]
        },
      {
        path: 'profile',
        loadChildren: () => import('@layouts/profile/profile.module').then(m => m.ProfileModule),
        data: { moduleName: 'PROFILE' }
      },
      {
        path: 'destinations',
        loadChildren: () => import('@myproject/components/destination/destination.module').then(m => m.DestinationModule),
        canActivate: [PermissionGuard],
        data: { moduleName: "DATAHUB" },
      },
    ]
  },
  { path: '**', redirectTo: '404' },
  { path: '404', component: PageNotFoundComponent }

];


export const AppRoutingModule: ModuleWithProviders<any> = RouterModule.forRoot(routes, {
    preloadingStrategy: CustomPreloadingStrategy
});

